<template>
    <dp v-model="date"
        valueType="format"
        @input="input"
        input-class="form-control"
         format="YYYY-MM-DD"
         placeholder="日付を入力"
    />
</template>
<script>
import Dp from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ja';

    export default {
        name: 'DatePicker',
        components: { Dp },
        props: {
            value: {
                type: String
            }
        },
        data(){
            return {
                date: ''
            }
        },
        mounted(){
            this.date = this.value;
        },
        methods:{
            input(date){
                this.$emit('input',this.date);
            }
        },
        watch:{
            value(newValue) {
                this.date = newValue;
            }
        }
    }
</script>
